export enum RentPlaceStatusEnum {
  RESERVED = "RESERVED",
  CONFIRMED = "CONFIRMED",
  WAITING_LIST = "WAITING_LIST",
  CANCELED = "CANCELED",
  PAID = "PAID",
}

export interface IRentPlace {
  id?: string | number;
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  place?: string;
  receipt_number?: string;
  institution?: string;
  event_name?: string;
  responsible_name?: string;
  responsible_phone?: string;
  observations?: string;
  is_free?: boolean;
  status: RentPlaceStatusEnum;
  rental_cost?: string | number;
  rental_discount?: string | number;
  rental_total?: string | number;
  payment_comment?: string;
  needs_invoice?: boolean;
  created_at: string;
  updated_at?: string;
  payment_date?: string;
}
